import { Country } from '@/integrations/crystallize/types/localization';

export function isNordics(countryCode: string): boolean {
  const nordicCountries = ['se', 'no', 'fi', 'dk'];
  return nordicCountries.includes(countryCode.toLowerCase());
}

/**
 * EU member states the shop sells to — where the EU legal guarantee label is mandatory. Deliberately
 * excludes the country-less fallback (`001`, used by /en, /de, …) and the non-EU markets we ship to
 * (ch, uk, us, no, tr, rs, …). Hungary is absent because the shop does not sell there.
 */
export function isEuCountry(countryCode: string): boolean {
  const euCountries = [
    'at', 'be', 'bg', 'hr', 'cy', 'cz', 'dk', 'ee', 'fi', 'fr', 'de', 'gr', 'ie',
    'it', 'lv', 'lt', 'lu', 'mt', 'nl', 'pl', 'pt', 'ro', 'sk', 'si', 'es', 'se',
  ];
  return euCountries.includes(countryCode.toLowerCase());
}

export function isVatIdSupportedForCountryArea(country: Country, areaCode?: string): boolean {
  if (areaCode && country.areas?.length) {
    const parts = areaCode.split('/');
    const localAreaCode = parts.length === 2 ? parts[1] : areaCode;
    const area = country.areas.find((a) => a.code === localAreaCode);
    if (area?.vatCheckoutAvailability !== undefined) {
      return area.vatCheckoutAvailability === true;
    }
  }

  return country.vatCheckoutAvailability === true;
}
